import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, initializeFirestore, persistentLocalCache, persistentMultipleTabManager, Firestore } from 'firebase/firestore';
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth';

// Firestore 配置
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDuKTxYnkNq3-akOl69PLDDjvd9xxPmCSo",
  authDomain: "pepwing.firebaseapp.com",
  projectId: "pepwing",
  storageBucket: "pepwing.firebasestorage.app",
  messagingSenderId: "35793986956",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:35793986956:web:15a214a8c30fc0e2dde2a9"
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

// 初始化 Firestore with named database
const FIRESTORE_DB = 'pepwing';

let db: Firestore;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  }, FIRESTORE_DB);
} catch (error) {
  console.warn('Failed to initialize Firestore with persistent cache, falling back to default:', error);
  db = getFirestore(app, FIRESTORE_DB);
}

// 初始化 Auth
const auth: Auth = getAuth(app);

// 開發環境連接模擬器（如果需要）
// 注意：Firestore 模擬器預設端口是 8088，不是 8080
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    connectFirestoreEmulator(db, 'localhost', 8088);
  } catch (error) {
    console.warn('Firestore emulator connection skipped:', error);
  }
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  } catch (error) {
    console.warn('Auth emulator connection skipped:', error);
  }
}

console.log('Firebase initialized with project:', firebaseConfig.projectId);

export { db, auth };